<template>
	<transition
		name="transition"
		:duration="{ enter: 750, leave: 250 }"
	>
		<nav
			id="mobile-nav"
			v-if="isShowing"
			:style="{'--height': primaryMenuHeight + 'px'}"
		>
			<div
				class='touch-close'
				@click="toggleMobileMenu()"
			></div>
			<div class="mobile-menu">

				<div
					class="mobile-menu__inner"
					v-bind:style="{ height: primaryMenuHeight + 'px' }"
				>

					<svg
						class='close-icon'
						@click="toggleMobileMenu()"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M2.41579 23.9262L0.082489 21.5929L9.41579 12.2596L0.082489 2.92616L2.41579 0.592865L11.7492 9.92616L21.0825 0.592865L23.4158 2.92616L14.0825 12.2596L23.4158 21.5929L21.0825 23.9262L11.7492 14.5929L2.41579 23.9262Z"
							fill="#211752"
						/>
					</svg>

					<div
						ref="menuDepth0"
						class="mobile-menu__panel mobile-menu__panel--depth-0"
						v-if="menuData"
						:class="{ current: depth == 0, previous: depth > 0 }"
					>

						<ul class="mobile-menu-links">
							<li v-if="showHomeLink">
								<a
									href="/"
									:class="{ selected: currentId <= 0 }"
								>Home</a>
							</li>

							<li
								v-for="post in menuData"
								:key="post.ID"
								:class="post.classes"
							>
								<div
									v-if="post.children && post.children.length > 0"
									:class="{
                    selected: post.object_id == currentId,
                  }"
									v-on:click.prevent="didSelectPost(post)"
								>
									<span v-html="post.title"></span>
								</div>
								<a
									v-else
									:href="post.url"
									:class="{
                    selected: post.object_id == currentId,
                  }"
								>
									<span v-html="post.title"></span>
								</a>

								<img
									v-if='post.children && post.children.length > 0'
									v-on:click.prevent="didSelectPost(post)"
									:src='arrow'
									alt='Has Children'
								/>

							</li>

							<primary-button
								v-if="globalSettings.general.cta"
								:link="globalSettings.general.cta"
								:label="globalSettings.general.cta.title"
								:target="globalSettings.general.cta.target"
							></primary-button>

							<secondary-button
								v-if="globalSettings.general.cta_two"
								:link="globalSettings.general.cta_two"
								:label="globalSettings.general.cta_two.title"
								:target="globalSettings.general.cta_two.target"
								theme='mob-menu'
							></secondary-button>

							<span class='sec-menu'>
								<li
									v-for="post in secMenuData"
									:key="post.ID"
									:class="post.classes"
									class='sec-menu__item'
								>

									<div
										class='icon-wrapper'
										v-if="post['menu_icon_alt']"
									>
										<img
											:src="post['menu_icon_alt']"
											:alt="post['title']"
										/>
									</div>

									<a
										:href="post.url"
										:class="{
                    selected: post.object_id == currentId,
                  }"
									>
										<span v-html="post.title"></span>
									</a>

									<img
										v-if='post.children && post.children.length > 0'
										v-on:click.prevent="didSelectPost(post)"
										:src='arrow'
										alt='Has Children'
									/>

								</li>
							</span>

						</ul>

					</div>

					<div
						ref="menuDepth1"
						class="mobile-menu__panel mobile-menu__panel--depth-1"
						v-if="menuForDepth1"
						:class="{
              current: depth == 1,
              previous: depth > 1,
              next: depth < 1,
            }"
					>
						<div
							v-if="selectedMenu0"
							class="mobile-menu-footer mega-menu-li-back"
						>
							<a
								:href="selectedMenu0.url"
								v-on:click.prevent="didSelectBack()"
								class="back"
							>

								<img
									:src='arrow'
									alt='Main Menu'
								/>

								<p>Main Menu</p>
							</a>
						</div>

						<ul
							class="mobile-menu-links"
							v-if="selectedMenu0"
						>
							<li
								:key="selectedMenu0.ID"
								class="mega-menu-li-header"
							>
								<a
									:href="selectedMenu0.url"
									v-on:click.prevent="didSelectPost(selectedMenu0, true)"
								>
									<h3 v-html="selectedMenu0.title"></h3>
								</a>
							</li>

							<template v-if="selectedMenu0.classes.includes('mega-menu')">
								<li
									v-for="post in menuForDepth1"
									:key="post.ID"
									:class="post.classes"
									class='mega-menu-li'
								>
									<a
										:href="post.url"
										:class="{
                    selected: post.object_id == currentId,
                  }"
										v-if="!post.classes.includes('hidden-title')"
									>

										<h5
											:class="post.classes.join(', ')"
											v-html="post.title"
										></h5>
									</a>

									<!-- {{ menuData[0].children[0].children }} -->

									<ul>
										<li
											v-for="(post, index) in post.children"
											:key="post.ID"
											:id='index'
											:class="[post.classes.join(', '), {'has-icon': post['menu_icon']}]"
										>

											<div
												class='icon-wrapper'
												v-if="post['menu_icon']"
											>
												<img
													:src="post['menu_icon']"
													:alt="post['title']"
												/>
											</div>

											<a
												:href="post.url"
												:class="post['classes'].join(', ')"
											>
												<span v-html="post.title"></span>
											</a>

											<svg
												v-if="post['classes'].includes('sub-cta')"
												width="7"
												height="11"
												viewBox="0 0 7 11"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M4.09024 5.14457L0.555176 1.60893L1.96951 0.194832L6.91845 5.14459L1.9695 10.0942L0.555184 8.68012L4.09024 5.14457Z"
													fill="#4F58F5"
												/>
											</svg>

										</li>
									</ul>

								</li>

								<div
									v-if='selectedMenu0.call_to_action_link'
									class='sub_menu_cta'
									:class="{'has-cta': selectedMenu0.call_to_action_link != null}"
								>
									<h3 v-html="selectedMenu0.call_to_action_description"></h3>

									<div
										class='sub_menu_cta__wrapper'
										v-if="selectedMenu0.call_to_action_link"
									>
										<secondary-button
											:link="selectedMenu0.call_to_action_link"
											:label="selectedMenu0.call_to_action_link.title"
											:target="selectedMenu0.call_to_action_link.target"
										></secondary-button>
									</div>
								</div>

							</template>
							<template v-else>
								<li
									v-for="post in menuForDepth1"
									:key="post.ID"
									:class="post.classes"
								>
									<div
										v-if="post.children && post.children.length > 0"
										:class="{
                    selected: post.object_id == currentId,
                  }"
										v-on:click.prevent="didSelectPost(post)"
									>
										<span v-html="post.title"></span>
									</div>
									<a
										v-else
										:href="post.url"
										:class="{
                    selected: post.object_id == currentId,
                  }"
									>
										<img
											class="icon"
											v-if="post.icon"
											:src="post.icon"
											:alt="post.title"
										/>
										<span v-html="post.title"></span>
									</a>
									<img
										v-if='post.children && post.children.length > 0'
										v-on:click.prevent="didSelectPost(post)"
										:src='arrow'
										alt='Has Children'
									/>
								</li>
							</template>
						</ul>

						<!-- <div
							v-if="selectedMenu0 && !selectedMenu0.classes.includes('mega-menu')"
							class="mobile-menu-footer"
						>
							<a
								:href="selectedMenu0.url"
								v-on:click.prevent="didSelectBack()"
								class="back"
							>

								<img
									:src='arrow'
									alt='Bkac'
								/>

								<p>Back</p>
							</a>
						</div> -->
					</div>

					<div
						ref="menuDepth2"
						class="mobile-menu__panel mobile-menu__panel--depth-2"
						v-if="menuForDepth2"
						:class="{
              current: depth == 2,
              previous: depth > 2,
              next: depth < 2,
            }"
					>
						<ul
							class="mobile-menu-links"
							v-if="selectedMenu1"
						>
							<li :key="selectedMenu1.ID">
								<a
									:href="selectedMenu1.url"
									v-on:click.prevent="didSelectPost(selectedMenu1, true)"
								>
									<h3 v-html="selectedMenu1.title"></h3>
								</a>
							</li>

							<li
								v-for="post in menuForDepth2"
								:key="post.ID"
								:class="post.classes"
							>
								<a
									:href="post.url"
									:class="{
                    selected: post.object_id == currentId,
                  }"
								><span v-html="post.title"></span></a>
								<img
									v-if='post.children && post.children.length > 0'
									v-on:click.prevent="didSelectPost(post)"
									:src='arrow'
									alt='Has Children'
								/>
							</li>
						</ul>

						<!-- <div
							v-if="selectedMenu1"
							class="mobile-menu-footer"
						>
							<a
								:href="selectedMenu1.url"
								v-on:click.prevent="didSelectBack()"
								class="back"
							><svg
									width="9"
									height="15"
									viewBox="0 0 9 15"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M3.09341 7.35333L8.38611 12.646L6.97189 14.0602L0.264988 7.35333L6.9719 0.646427L8.38611 2.06064L3.09341 7.35333Z"
										fill="#00AEEF"
									/>
								</svg>

								<p>Back</p>
							</a>
						</div> -->
					</div>

					<div
						ref="menuDepth3"
						class="mobile-menu__panel mobile-menu__panel--depth-3"
						v-if="menuForDepth3"
						:class="{ current: depth == 3, next: depth < 3 }"
					>
						<ul class="mobile-menu-links">
							<li
								v-for="post in menuForDepth3"
								:key="post.ID"
								:class="post.classes"
							>

								<a
									:href="post.url"
									:class="{
                    selected: post.object_id == currentId,
                  }"
								>
									<span v-html="post.title"></span>
								</a>

								<img
									v-if='post.children && post.children.length > 0'
									v-on:click.prevent="didSelectPost(post)"
									:src='arrow'
									alt='Has Children'
								/>

							</li>
						</ul>

						<!-- <div
							v-if="selectedMenu2"
							class="mobile-menu-footer"
						>
							<a
								:href="selectedMenu2.url"
								v-on:click.prevent="didSelectBack()"
								class="back"
							>

								<svg
									width="9"
									height="15"
									viewBox="0 0 9 15"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M3.09341 7.35333L8.38611 12.646L6.97189 14.0602L0.264988 7.35333L6.9719 0.646427L8.38611 2.06064L3.09341 7.35333Z"
										fill="#00AEEF"
									/>
								</svg>

								<p>Back</p>
							</a>
						</div> -->
					</div>

				</div>
			</div>
		</nav>

	</transition>
</template>

<script>
import Arrow from '../../images/mobile-children.svg';
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';
import Search from '../../images/search.svg';

export default {
	data() {
		return {
			selectedPrimaryPost: null,
			selectedSecondaryPost: null,
			selectedTertiaryPost: null,
			selectedMenuData: null,
			arrow: Arrow,
			searchQuery: '',
			searchIcon: Search,
			depth: 0,
			primaryMenuHeight: 300,
			selectedMenu0: null,
			selectedMenu1: null,
			selectedMenu2: null,
			selectedMenu3: null,
		};
	},

	props: {
		menuData: {
			type: Array,
			default: function () {
				return [];
			},
		},
		secMenuData: {
			type: Array,
			default: function () {
				return [];
			},
		},
		globalSettings: {},
		currentId: {
			type: Number,
			default: -1,
		},
		isShowing: {
			type: Boolean,
			default: false,
		},
		showHomeLink: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		menuForDepth1: function () {
			return this.selectedMenu0 ? this.selectedMenu0.children : [];
		},
		menuForDepth2: function () {
			return this.selectedMenu1 ? this.selectedMenu1.children : [];
		},
		menuForDepth3: function () {
			return this.selectedMenu2 ? this.selectedMenu2.children : [];
		},
		parsedMenuData() {
			if (this.menuData) {
				return this.menuData;
			} else {
				return null;
			}
		},
	},

	watch: {
		// depth: function (newValue, oldValue) { // eslint-disable-line no-unused-vars
		//   //this.layoutSubviews();
		// },
		// isShowing: function (newValue, oldValue) {
		//   // if(newValue) {
		//   //
		//   // }
		// },
	},

	methods: {
		toggleMobileMenu() {
			this.$store.commit('toggleMobileMenu', !this.$store.state.mobile_menu);
		},

		triggerToggleSearch() {
			this.$emit('trigger-toggle-search');
		},

		layoutSubviews: function () {
			var height = 0,
				panelEl = this.$refs['menuDepth' + this.depth];

			if (typeof panelEl === 'undefined') return;

			height = panelEl.clientHeight;
			this.primaryMenuHeight = height;
		},
		didSelectBack: function () {
			if (this.depth > 0) {
				this.depth -= 1;
			}
		},
		didSelectPost: function (item, ignoreChildren = false) {
			const self = this;

			if (item.children && !ignoreChildren) {
				var newDepth = item.depth + 1;

				switch (newDepth) {
					case 1:
						{
							self.selectedMenu0 = item;
						}
						break;

					case 2:
						{
							self.selectedMenu1 = item;
						}
						break;

					case 3:
						{
							self.selectedMenu2 = item;
						}
						break;

					default:
				}

				self.depth = newDepth;

				return;
			}

			window.location.href = item.url;
			// self.isShowingMenu = false;
		},
	},

	components: {
		PrimaryButton,
		SecondaryButton,
		//PoseTransition,
	},

	mounted() {
		var self = this;
		setTimeout(function () {
			self.layoutSubviews();
		}, 150);
	},

	updated() {
		this.layoutSubviews();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

$mobile-menu-item-min-height: 72px;
$mobile-menu-footer-min-height: 82px;

#mobile-nav {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 999;
	-webkit-overflow-scrolling: touch;

	.touch-close {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
	}

	.scrolled & {
		position: fixed;
		/* top: 84px;
		background-color: transparent;
		height: var(--height);

		&::before {
			content: '';
			position: absolute;
			top: -84px;
			left: 0;
			right: 0;
			height: 84px;
			background: var(--chartruese-green);
		}

		.mobile-menu {
			background-color: var(--chartruese-green);

			&__inner {
				background-color: var(--chartruese-green);
			}
		} */
	}

	/* .admin-bar & {
		//top: $header-height-xs + $admin-bar-height-xs;
		padding-top: $header-height-xs + $admin-bar-height-xs;

		@media (max-width: $tablet) {
			//top: $header-height-xs + $admin-bar-height;
			padding-top: $header-height-xs + $admin-bar-height;
		}
	} */

	&.fade-enter-active,
	&.fade-leave-active {
		transition: opacity 0.25s;

		.container {
			transition: transform 0.25s;
		}
	}

	&.fade-enter,
	&.fade-leave-to {
		opacity: 0;
	}

	&.fade-leave-to {
		.container {
			transform: translateY(-10px);
		}
	}

	&.transition-enter-active,
	&.transition-leave-active {
		transition: background 0.15s ease-in-out, opacity 0.1s ease-in-out;

		.mobile-menu {
			transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
		}
	}

	&.transition-enter-active {
		.mobile-menu {
			transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);

			.page-showing-menu & {
				transition-delay: 0.25s;
			}
		}
	}

	&.transition-leave-active {
		.mobile-menu {
			transition-duration: 0.25s;
			transition-timing-function: cubic-bezier(0.36, 0, 0.22, 0);
		}
	}

	&.transition-enter,
	&.transition-leave-to {
		/* background-color: var(--white); */

		.mobile-menu {
			//opacity: 0;
			transform: translateX(120%);
		}
	}

	.mobile-menu {
		/* position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0; */
		/* overflow: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between; */
		background: transparent;
		transition: 0.2s ease all;
		justify-content: flex-end;
		display: flex;
		position: relative;
		pointer-events: none;

		&__inner {
			position: relative;
			overflow: hidden;
			background: var(--light-grey);
			color: var(--white);
			transition: 0.2s ease all;
			height: 100vh !important;
			width: calc(100vw - 80px) !important;
			right: 0;
			/* border-left: var(--border); */
			pointer-events: all;
			overflow-y: hidden;

			.close-icon {
				position: absolute;
				right: 20px;
				top: 20px;
				display: flex;

				&:hover {
					cursor: pointer;
				}
			}

			.back {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				/* border-top: var(--border-bright); */
				position: relative;
				text-decoration: none;
				color: var(--midnight);
				opacity: 1;
				gap: 9.5px;
				font: normal normal bold 14px/18px var(--primary-font-family);
				letter-spacing: 0.14px;
				padding: 0 0 24px;

				&:hover,
				&:active {
					text-decoration: none;
					opacity: 1;
				}

				img {
					transform: rotate(-180deg);
				}

				svg {
					/* transform: rotate(-180deg); */

					/* path {
						stroke: var(--midnight);
					} */

					path {
						fill: var(--midnight);
					}
				}

				p,
				span {
					color: var(--midnight);
					font-weight: 600;
					font-size: 15px;
					line-height: 18px;
				}
			}
		}

		&__panel {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: $z-index-low;
			transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
			margin-top: 55px;
			/* padding-top: 16px; */
			overflow-y: scroll;

			&--depth-1,
			&--depth-2,
			&--depth-3 {
				margin-top: 0;
			}

			body.logged-in &,
			body.admin-bar & {
				margin-top: 48px + 32px;

				@media (max-width: $mobile-xl) {
					margin-top: 48px + 41px;
				}
			}

			&.next {
				pointer-events: none;
				transform: translateX(50%);
				opacity: 0;
			}

			&.current {
				pointer-events: all;
				transform: translateX(0);
				opacity: 1;
				z-index: $z-index-medium;
			}

			&.previous {
				pointer-events: none;
				transform: translateX(-50%);
				opacity: 0;
			}

			.mobile-menu-footer {
				padding: 0 $page-gutter-width-xs;
				margin-top: 24px;

				&.mega-menu-li {
					&-back {
						.back {
							padding-bottom: 0;
						}
					}
				}
			}

			.mobile-menu-links {
				list-style: none;
				margin: 0;
				padding: 20px $page-gutter-width-xs 16px $page-gutter-width-xs;

				.search {
					display: flex;
					gap: 10px;
					margin-bottom: 16px;

					&:hover {
						cursor: pointer;
					}

					p {
						margin: 0;
						color: var(--midnight);
					}

					img {
						width: 20px;
					}
				}

				> li {
					margin: 0;
					padding: 0;
					display: block;
					display: flex;
					justify-content: space-between;

					.mobile-menu__panel--depth-0 & {
						border-bottom: 1px solid var(--midnight);
					}

					&:first-child {
						border-top: none;
					}

					&:last-of-type {
						border-bottom: none;
					}

					> img {
						padding: 16px 0 16px 32px;

						&:hover {
							cursor: pointer;
						}
					}

					> a,
					> div {
						position: relative;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						/* min-height: $mobile-menu-item-min-height; */
						color: var(--midnight);
						opacity: 1;
						text-decoration: none;
						padding: 16px 0 16px;
						width: 100%;
						column-gap: 16px;

						&:hover,
						&:active {
							text-decoration: none;
							opacity: 1;
							cursor: pointer;

							&::before {
								opacity: 1;
								//background-color: map-get($theme-colours, ocean-blue);
							}

							&::after {
								transform: translateX(5px);
							}
						}

						&.selected {
							//color: map-get($theme-colours, ocean-blue);
							/* opacity: 0.7; */

							&.has-children {
								&:hover,
								&:active {
									text-decoration: none;
								}
							}
						}

						h3 {
							color: var(--cobalt);
							margin: 0;
						}

						span {
							color: var(--midnight);
						}
					}

					&.mega-menu-li {
						display: flex;
						flex-direction: column;
						border-bottom: 0;
						margin-bottom: 32px;

						&-back {
							.back {
								padding-bottom: 0;
							}
						}

						&-header {
							border-bottom: 0;
							padding-top: 0;
							margin-top: 16px;
							margin-bottom: 32px;

							&:first-child {
								padding-top: 0;
							}

							a {
								padding-bottom: 0;

								h3 {
									margin: 0;
								}
							}
						}

						> a {
							span {
								font: normal normal normal 14px/20px var(--primary-font-family);
								text-transform: uppercase;
								color: var(--midnight);

								&.hidden-title {
									display: none;
								}
							}

							h5 {
								color: var(--cobalt);
								text-transform: uppercase;
								margin: 0;
							}
						}

						ul {
							list-style: none;
							padding: 0;
							display: flex;
							flex-wrap: wrap;
							flex-direction: column;
							gap: 16px;

							li {
								display: flex;
								flex-wrap: wrap;
								align-items: center;

								&.has-icon {
									display: grid;
									grid-template-columns: 32px 1fr;
									gap: 16px;
								}

								&.sub-cta {
									margin-top: 16px;
									margin-bottom: 16px;
								}

								.icon-wrapper {
									margin-right: 16px;
									width: 32px;
									display: flex;
								}

								svg {
									margin-left: 8px;
								}

								a {
									text-decoration: none;
									color: var(--midnight);
									padding: 0;

									&.sub-cta {
										span {
											font-weight: 600;
											font-size: 15px;
											line-height: 18px;
										}
									}

									&.secondary {
										span {
											font-weight: 400;
											font-size: 14px;
											line-height: 18px;
										}
									}
								}
							}
						}
					}
				}

				.sub_menu_cta {
					grid-column: span 1;
					background: var(--emerald);
					/* margin-top: -30px;
					margin-bottom: -30px;
					margin-right: -24px; */
					padding: 24px;
					display: flex;
					flex-wrap: wrap;
					flex-direction: column;
					justify-content: flex-start;
					position: relative;
					margin-right: -20px;
					margin-left: -20px;
					margin-top: 48px;

					&.has-cta {
						justify-content: space-between;
					}

					&::after {
						content: '';
						position: absolute;
						left: 0;
						bottom: -100%;
						height: 100%;
						width: 100%;
						background: var(--emerald);
					}

					h3 {
						margin-top: 0;
					}
				}

				.sec-menu {
					margin-top: 56px;
					display: flex;
					flex-direction: column;
					flex-wrap: wrap;
					gap: 24px;

					&__item {
						display: flex;
						gap: 8px;

						.icon-wrapper {
							display: flex;
						}

						a {
							text-decoration: none;
							width: 100%;

							span {
								color: var(--midnight);
							}
						}
					}
				}

				.site_button {
					margin-top: 32px;
				}
			}
			/* 
			h5 {
				color: var(--light-blue);
			} */
			&--depth-0 {
				.mobile-menu-links {
					> li {
						border-bottom: 1px solid var(--cobalt);
					}
				}
			}

			&--depth-1,
			&--depth-2,
			&--depth-3,
			&--depth-4 {
				.mobile-menu-links {
					padding: 0 $page-gutter-width-xs 0 $page-gutter-width-xs;

					> li {
						/* border-bottom: none; */

						a {
							padding: 24px 0 16px;
						}

						&:first-child {
							/* border-bottom: var(--border); */
							padding-top: 16px;
							padding-bottom: 0;
							border-top: 0;

							a {
								border: none;
								opacity: 1;
								font: normal normal 600 24px/28px var(--primary-font-family);
								letter-spacing: 0px;
								color: var(--white);
							}
						}

						&:last-child {
							> a {
								padding: 0 0 16px 0;
							}
						}

						> a {
							opacity: 1;
							color: var(--white);
							text-transform: none;
							min-height: auto;
							padding: 0 0 16px;
						}

						/* &:not(:first-child) {
							border-top: 0;
						} */
					}
				}
			}
		}

		&__footer {
			text-align: center;
			padding: 0 $page-gutter-width-xs;
			// padding-top: ($grid-gutter-width/2);
			// padding-bottom: 0;

			.search-box {
				margin-bottom: ($grid-gutter-width/2);
			}

			.social {
				justify-content: flex-start;
				margin-bottom: ($grid-gutter-width/2);
			}
		}
	}
}

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>
